import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useTaskStatus, TaskStatus } from './useData';
import {
  moduleConfig,
  getInitialFormData,
  mapItemToFormData,
} from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<TaskStatus>
      useData={useTaskStatus}
      config={{
        ...moduleConfig,
        getInitialFormData,
        mapItemToFormData,
      }}
    />
  );
};

export default Form;
